// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see CheckDepositStartEvent
 */
export var CheckDepositStart = function (_a) {
    var source = _a.source;
    return ({
        name: "Check Deposit Start",
        parameters: {
            cdf_entity: "Check",
            cdf_action: "Deposit",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CheckDepositEnterAmountEvent
 */
export var CheckDepositEnterAmount = function (_a) {
    var amount = _a.amount, currencyCode = _a.currencyCode;
    return ({
        name: "Check Deposit EnterAmount",
        parameters: {
            cdf_entity: "Check",
            cdf_action: "Deposit",
            amount: amount !== undefined && amount !== null ? amount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            currency_code: currencyCode !== undefined && currencyCode !== null ? currencyCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CheckDepositConfirmEvent
 */
export var CheckDepositConfirm = function (_a) {
    var side = _a.side;
    return ({
        name: "Check Deposit Confirm",
        parameters: {
            cdf_entity: "Check",
            cdf_action: "Deposit",
            side: side !== undefined && side !== null ? side.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CheckDepositViewInstructionsEvent
 */
export var CheckDepositViewInstructions = function () { return ({
    name: "Check Deposit ViewInstructions",
    parameters: {
        cdf_entity: "Check",
        cdf_action: "Deposit",
    }
}); };
/**
 * @see CheckDepositVerifyEvent
 */
export var CheckDepositVerify = function (_a) {
    var captureMode = _a.captureMode, side = _a.side, state = _a.state;
    return ({
        name: "Check Deposit Verify",
        parameters: {
            cdf_entity: "Check",
            cdf_action: "Deposit",
            capture_mode: captureMode !== undefined && captureMode !== null ? captureMode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            side: side !== undefined && side !== null ? side.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            state: state !== undefined && state !== null ? state.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CheckDepositReceiveErrorEvent
 */
export var CheckDepositReceiveError = function (_a) {
    var captureWarnings = _a.captureWarnings, httpErrorCode = _a.httpErrorCode, isNetworkFailure = _a.isNetworkFailure, step = _a.step;
    return ({
        name: "Check Deposit ReceiveError",
        parameters: {
            cdf_entity: "Check",
            cdf_action: "Deposit",
            capture_warnings: captureWarnings !== undefined && captureWarnings !== null ? captureWarnings.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            http_error_code: httpErrorCode !== undefined && httpErrorCode !== null ? httpErrorCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_network_failure: isNetworkFailure !== undefined && isNetworkFailure !== null ? isNetworkFailure.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            step: step !== undefined && step !== null ? step.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CheckDepositCompleteEvent
 */
export var CheckDepositComplete = function (_a) {
    var amount = _a.amount, currencyCode = _a.currencyCode;
    return ({
        name: "Check Deposit Complete",
        parameters: {
            cdf_entity: "Check",
            cdf_action: "Deposit",
            amount: amount !== undefined && amount !== null ? amount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            currency_code: currencyCode !== undefined && currencyCode !== null ? currencyCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CheckDepositExitEvent
 */
export var CheckDepositExit = function (_a) {
    var step = _a.step;
    return ({
        name: "Check Deposit Exit",
        parameters: {
            cdf_entity: "Check",
            cdf_action: "Deposit",
            step: step !== undefined && step !== null ? step.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
